import React, { FC, useEffect } from 'react';
import { isEmpty } from 'lodash';
import { CompanyReviewFeedItem } from '@src/containers/Feed/CompanyReviewFeedItem';
import { CompanyAwardFeedItem } from '@src/containers/Feed/CompanyAwardFeedItem';
import { Wrapper } from '@src/components/Wrapper';
import { FeedItemSkeleton } from '@src/components/Skeletons/FeedItemSkeleton';
import { COMPANY_REVIEW_TYPES } from '@src/constants';
import { MetricAction, MetricContext } from '@src/metrics/metrics.enum';
import { useReplyToReviewMutation } from '@src/graphql/generated';
import { trackEvent } from '@src/metrics';
import { useCompanyReviews } from './useCompanyReviews';
import { CompanyRatingsCard } from './CompanyRatingsCard';
import { EmptyState } from './EmptyState';
import './styles.scss';

export const Reviews: FC = () => {
  const { reviews, companyRatings, isInitialLoading, isFetchMoreLoading } = useCompanyReviews();

  const [createReply] = useReplyToReviewMutation();

  useEffect(() => {
    trackEvent({
      context: MetricContext.COMPANY_REVIEWS_VIEW,
      interaction: MetricAction.OPEN_COMPANY_REVIEWS,
    });
  }, []);

  const onPost = (message: string, reviewId: string): void => {
    createReply({
      variables: {
        replyToReviewInput: {
          comment: message,
        },
        reviewId: reviewId,
      },
    });

    trackEvent({
      context: MetricContext.COMPANY_REVIEWS_VIEW,
      interaction: MetricAction.OPEN_COMPANY_REVIEWS,
    });
  };

  if (!isInitialLoading && isEmpty(reviews)) {
    return (
      <Wrapper className="company-reviews">
        <div className="company-reviews__empty-state">
          <EmptyState />
        </div>
      </Wrapper>
    );
  }

  return (
    <Wrapper className="company-reviews">
      <>
        <div className="company-reviews__feed">
          {!isEmpty(reviews) &&
            reviews.map(review => {
              switch (review.type) {
                case COMPANY_REVIEW_TYPES.COMPANY_RATINGS:
                  return (
                    <CompanyReviewFeedItem
                      key={review.id}
                      onPost={onPost}
                      review={review}
                      wrapperClassName="company-reviews__feed-item"
                    />
                  );
                case COMPANY_REVIEW_TYPES.COMPANY_AWARDS:
                  return (
                    <CompanyAwardFeedItem
                      key={review.id}
                      onPost={onPost}
                      review={review}
                      wrapperClassName="company-reviews__feed-item"
                    />
                  );
                default:
                  return null;
              }
            })}

          {(isInitialLoading || isFetchMoreLoading) && <FeedItemSkeleton />}
        </div>

        {!isInitialLoading && !isEmpty(reviews) && companyRatings && (
          <div className="company-reviews__overall-ratings">
            <CompanyRatingsCard ratings={companyRatings} />
          </div>
        )}
      </>
    </Wrapper>
  );
};
